module.exports = __webpack_public_path__ + "img/gartek-services-plans-review-inspections-construction-safety.97213a09.png";